import React from 'react';
import { HamburgerContainer as Container } from '../../../Style';

export const Hamburger = ({ toggleMenu }) => {
    return (
    <Container onClick={toggleMenu}>
            <i id="menu-hamburger" className="fa fas fa-bars"></i>
        </Container>
    )
}